import { atom } from 'recoil';

/**
 * @desc API 문서(OpenAPI/Swagger JSON) 데이터 상태
 */
export const apiDocsState = atom({
  key: 'apiDocsState',
  default: null, // 초기값 null (로딩 전)
});
